export const getProductName = function (productId) {
  switch (productId) {
    case 'InteractiveBowling':
      return 'Interactive Bowling'

    case 'InteractivePanel':
      return 'Interactive Panel'

    default:
      return productId
  }
}



// WEBPACK FOOTER //
// ./src/helpers/products.js